import React from 'react';
import { motion } from 'framer-motion';
interface ProgressRingProps {
  progress: number; // 0-100
  size?: number;
  strokeWidth?: number;
  trackColor?: string;
  progressColor?: string;
  children?: React.ReactNode;
}
export function ProgressRing({
  progress,
  size = 56,
  strokeWidth = 5,
  trackColor = '#E2E8F0',
  progressColor = '#0D9488',
  children
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.min(Math.max(progress, 0), 100);
  const offset = circumference - clamped / 100 * circumference;
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-148" data-mp="sqrklqyompzc">
      <svg width={size} height={size} className="-rotate-90" data-id="element-149" data-mp="ntrghlle7xav">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke={trackColor} strokeWidth={strokeWidth} fill="none" data-id="element-150" data-mp="2uixnosljmf1x" />
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke={progressColor} strokeWidth={strokeWidth} fill="none" strokeLinecap="round" strokeDasharray={circumference} initial={false} animate={{
        strokeDashoffset: offset
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-151" data-mp="2pkmbib7rzsgj" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-152" data-mp="73s6pttxp7si">{children}</div>
    </div>;
}